import { createAction, createSlice } from "@reduxjs/toolkit";
import {
	Campaign,
	CampaignQueryParams,
	CampaignRule,
	CampaignUser,
} from "../type";
import { RootState } from "store/store";

export interface DefaultQueryRuleQueryParams {
	skip: number;
	take: number;
}

export interface CampaignState {
	campaignList: Campaign[];
	campaignDetail?: Campaign;
	campaignTotal: number;
}

const initialState: CampaignState = {
	campaignList: [],
	campaignTotal: 0,
};

export const campaignSlice = createSlice({
	name: "campaign",
	initialState: initialState,
	reducers: {
		setCampaignList: (state, action) => {
			state.campaignList = action.payload.data;
			state.campaignTotal = action.payload.total;
		},
		setCampaignDetail: (state, action) => {
			state.campaignDetail = action.payload.data;
		},
		changStatusCampaign: (state, action) => {
			const { id, status } = action.payload;
			const index = state.campaignList.findIndex(el => el._id === id);
			state.campaignList[index].status = status;
		},
	},
});

export const { setCampaignList, setCampaignDetail, changStatusCampaign } =
	campaignSlice.actions;

export const selectCampaignList = (state: RootState) =>
	state.campaign.campaignList;
export const selectCampaignDetail = (state: RootState) =>
	state.campaign.campaignDetail;
export const selectCampaignTotal = (state: RootState) =>
	state.campaign.campaignTotal;

export interface GetListCampaignPayload {
	query: CampaignQueryParams;
	callback: () => void;
	cancelLoading?: () => void;
}

export const getListCampaignAsync = createAction(
	"campaign/getListCampaignAsync",
	(payload: GetListCampaignPayload) => ({
		payload,
	}),
);

export interface GetDetailCampaignPayload {
	id: string;
	callback: (response: Campaign) => void;
}

export const getDetailCampaignAsync = createAction(
	"campaign/getDetailCampaignAsync",
	(payload: GetDetailCampaignPayload) => ({
		payload,
	}),
);

export interface CreateCampaignPayload {
	callback: (data: any) => void;
	data: Campaign;
}

export const createCampaignAsync = createAction(
	"campaign/createCampaignAsync",
	(payload: CreateCampaignPayload) => ({
		payload,
	}),
);

export interface CreateCampaignRulePayload {
	callback?: () => void;
	data: {
		campaign: string;
		rules: CampaignRule[];
	};
}

export const createCampaignRuleAsync = createAction(
	"campaign/createCampaignRuleAsync",
	(payload: CreateCampaignRulePayload) => ({
		payload,
	}),
);

export interface CreateCampaignUserPayload {
	callback?: () => void;
	data: {
		campaign: string;
		users: CampaignUser[];
	};
}

export const createCampaignUserAsync = createAction(
	"campaign/createCampaignUserAsync",
	(payload: CreateCampaignUserPayload) => ({
		payload,
	}),
);

export interface UpdateCampaignPayload {
	id: string;
	callback: () => void;
	data: Campaign;
}

export const updateCampaignAsync = createAction(
	"campaign/updateCampaignAsync",
	(payload: UpdateCampaignPayload) => ({
		payload,
	}),
);

export interface UpdateStatusCampaignPayload {
	id: string;
	callback: () => void;
	data: {
		status: string;
	};
}

export const updateStatusCampaignAsync = createAction(
	"campaign/updateStatusCampaignAsync",
	(payload: UpdateStatusCampaignPayload) => ({
		payload,
	}),
);

export interface DeleteCampaignPayload {
	id: string;
	callback?: () => void
};

export const deleteCampaignAsync = createAction(
	"campaign/deleteCampaignAsync",
	(payload: DeleteCampaignPayload) => ({
		payload,
	}),
);

export interface GetListUserCampaignPayload {
	id: string;
	query: DefaultQueryRuleQueryParams;
	callback?: (data: any[]) => void;
}

export const getListUserCampaignAsync = createAction(
	"campaign/getListUserCampaignAsync",
	(payload: GetListUserCampaignPayload) => ({
		payload,
	}),
);

export interface GetListRuleCampaignPayload {
	id: string;
	query: DefaultQueryRuleQueryParams;
	callback: (response: CampaignRule[]) => void;
}

export const getListRuleCampaignAsync = createAction(
	"campaign/getListRuleCampaignAsync",
	(payload: GetListRuleCampaignPayload) => ({
		payload,
	}),
);

export interface DeleteRuleCampaignPayload {
	id: string;
	callback: () => void;
}

export const deleteRuleCampaignAsync = createAction(
	"campaign/deleteRuleCampaignAsync",
	(payload: DeleteRuleCampaignPayload) => ({
		payload,
	}),
);


export default campaignSlice.reducer;
